// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import('core-js/stable');
import('regenerator-runtime/runtime');
import('src/plugins');
import('src/submission');
import('src/degree');
import('src/portfolio_item');
import('src/fileUpload');
import('src/word-counter');
import { Filterrific } from './filterrific-jquery'; global.Filterrific = Filterrific;
import('src/admin');
import('src/assessment');
require("turbolinks").start();
require("@rails/ujs").start();
require("@rails/activestorage").start();
require("channels");

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

$(document).on('click', '.btn-close', function() {
	$(this).parent('.alert').remove();
});

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
})
